<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('quality.quality_test_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-md-3">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('quality.quality_test_name')}...`"
        ></fg-input>
      </div>
      <div class="col-3">
        <div class="form-group has-label">
          <label>{{ $t('common_words.type_grade') }} *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-default mb-3 shadow-sm required-catch-type"
            v-model="model.catch_type"
            :placeholder="`${$t('common_words.select')}...`"
            v-bind:disabled="change_type"
          >
            <el-option
              class="select-default"
              :label="$t('common_words.per_allotment')"
              value="1"
            >
            </el-option>
            <el-option
              class="select-default"
              :label="$t('common_words.per_farm')"
              value="2"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-3">
        <div class="form-group has-label">
          <label>{{ $t('common_words.type_capture') }} *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm required-audit-type"
            size="large"
            v-model="model.audit2_type"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in advancedAuditTypes"
              class="select-primary"
              :value="option.id"
              :label="option.label"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-3">
        <fg-input
          type="number"
          :label="$t('common_words.record_quant')"
          min="1"
          v-model.number="model.total_records"
          name="common_words.record_quantity"
          v-validate="modelValidations.total_records"
          :error="getError('common_words.record_quantity', true)"
          :placeholder="`${$t('common_words.records_number')}...`"
        ></fg-input>
      </div>
      <div class="col-md-3">
        <fg-input
          type="text"
          :label="$t('common_words.record_name')"
          v-model="model.record_name"
          name="nombre de los registros"
          :placeholder="`${$t('common_words.records_name')}...`"
        ></fg-input>
      </div>
      <div class="col-md-3">
        <fg-input
          step="0.01"
          min="0"
          max="100"
          type="number"
          :label="$t('common_words.general_percentage_by_task')"
          v-model="model.discount_percentage"
          name="common_words.general_percentage_by_task"
          v-validate="modelValidations.discount_percentage"
          :error="getError('common_words.general_percentage_by_task', true)"
          placeholder="0.01"
        ></fg-input>
      </div>
      <div class="col-3" v-if="isSuper()">
        <div class="form-group has-label">
          <label>{{ $t('ad_audit.where_to_use') }} *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm required-where-use"
            size="large"
            v-model="model.where_to_use"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in whereToUses"
              class="select-primary"
              :value="option.value"
              :label="option.label"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-4 col-md-4 col-lg-3 col-xl-3">
        <div class="form-group has-label">
          <label>{{ $t('common_words.require_signature') }}</label>
          <el-switch
            v-model="model.signature"
            style="display: block; margin-top: 0.5rem"
            active-color="#6BA652"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label>{{ $t('common_words.description') }}</label>
          <br />
          <el-input
            maxlength="500"
            show-word-limit
            type="textarea"
            :rows="2"
            placeholder="..."
            v-model="model.description"
            class="shadow-sm"
          ></el-input>
          <br />
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label>{{ $t('common_words.select_associated_companies') }}</label>
          <br />
          <el-select
            @change="selectAllFromSelect('model.businesses_id', businesses)"
            multiple
            clearable
            filterable
            class="select-primary custom-width-select required-first-step shadow-sm"
            size="large"
            v-model="model.businesses_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-6">
        <div class="form-group has-label">
          <label>{{ $t('common_words.select_associated_profiles') }}</label>
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.roles_id', availableRoles)"
            multiple
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.roles_id"
            :placeholder="`${$t('common_words.admin')}...`"
          >
            <el-option
              v-for="option in availableRoles"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group has-label">
          <label>{{ $t('common_words.select_associated_users') }}</label>
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.users_id', availableUsers)"
            multiple
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.users_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in availableUsers"
              class="select-primary selected-all"
              :value="option.id"
              :label="`${option.name}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { convertFirstLetterUppercase } from 'src/util/Util.js';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import store from '@/store';

export default {
  data() {
    return {
      model: {
        name: null,
        total_records: 1,
        record_name: null,
        discount_percentage: null,
        description: null,
        catch_type: null,
        businesses_id: [],
        roles_id: [],
        users_id: [],
        audit2_type: 'web',
        where_to_use: 'Auditoria Avanzada',
        signature: false,
      },
      modelValidations: {
        name: {
          required: true,
        },
        discount_percentage: {
          min_value: 0,
          max_value: 100,
        },
        total_records: {
          min_value: 1,
        },
      },
      businesses: [],
      roles: [],
      users: [],
      change_type: false,
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinMasters],

  computed: {
    whereToUses() {
      return [
        {
          id: 0,
          value: 'Auditoria Avanzada',
          label: i18n.t('ad_audit.advanced_audit'),
        },
        {
          id: 1,
          value: 'Trabajo Estandarizado',
          label: i18n.t('ad_audit.standardized_work'),
        },
        {
          id: 2,
          value: 'Matriz de Competencias',
          label: i18n.t('ad_audit.competency_matriz'),
        },
        {
          id: 3,
          value: 'HIP',
          label: 'HIP',
        },
        {
          id: 4,
          value: 'Compromiso',
          label: i18n.t('ad_audit.commitment'),
        },
        {
          id: 5,
          value: 'Hora a Hora',
          label: i18n.t('ad_audit.hour_by_hour'),
        },
      ];
    },

    availableRoles() {
      const tmp = [...this.model.roles_id];
      if (this.model.businesses_id.length > 0) {
        this.model.roles_id = [];
        const response = this.roles.filter((rol) => {
          const businessAffiliates = rol.business.filter((bs) =>
            this.model.businesses_id.includes(bs.id)
          );
          return businessAffiliates.length > 0;
        });

        response.forEach((rol) => {
          if (tmp.includes(0)) this.model.roles_id.push(rol.id);
          else if (tmp.includes(rol.id)) this.model.roles_id.push(rol.id);
        });

        return this.concatAll(response);
      } else return this.concatAll([]);
    },

    availableUsers() {
      const tmp = [...this.model.users_id];
      if (this.model.businesses_id.length > 0) {
        this.model.users_id = [];
        const response = this.users.filter((user) => {
          const businessAffiliates = user.business.filter((bs) =>
            this.model.businesses_id.includes(bs.id)
          );
          return businessAffiliates.length > 0;
        });

        response.forEach((user) => {
          if (tmp.includes(0)) this.model.users_id.push(user.id);
          else if (tmp.includes(user.id)) this.model.users_id.push(user.id);
        });

        return this.concatAll(response);
      } else return this.concatAll([]);
    },
    advancedAuditTypes() {
      return [
        { id: 'web', label: i18n.t('common_words.web') },
        { id: 'mobile', label: i18n.t('common_words.mobile') },
        { id: 'both', label: i18n.t('common_words.both') },
      ];
    },
  },

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        if (res) {
          if (!this.model.catch_type)
            return store.dispatch(
              'utils/validationInputsRequired',
              '-catch-type'
            );
          if (!this.model.audit2_type && this.model.audit2_type.length == 0)
            return store.dispatch(
              'utils/validationInputsRequired',
              '-audit-type'
            );
          if (!this.model.where_to_use && this.model.where_to_use.length == 0)
            return this.validationInputsRequired('where-use');
          if (this.model.businesses_id.length == 0)
            return store.dispatch(
              'utils/validationInputsRequired',
              '-first-step'
            );

          const name = convertFirstLetterUppercase(this.model.name);
          this.model.name = name;
          this.$emit('on-validated', res, this.model);

          const others = [];
          this.model.businesses_id.map((businessId) =>
            this.businesses.map(
              ({ id, name }) => businessId === id && others.push(name)
            )
          );

          const othersRoles = [];
          this.model.roles_id.map((roleId) =>
            this.roles.map(
              ({ id, name }) => roleId === id && othersRoles.push(name)
            )
          );

          const othersUsers = [];
          this.model.users_id.map((userId) =>
            this.users.map(
              ({ id, first_name, last_name, username }) =>
                userId === id &&
                othersUsers.push(`${first_name} ${last_name} (${username})`)
            )
          );

          this.$emit('fillAdvancedAuditForm', 'firstStep', {
            business_name: others,
            roles_name: othersRoles,
            users_name: othersUsers,
            type: this.model.catch_type == 1 ? 'Por Lote' : 'Por Finca',
            audit_type_label: this.advancedAuditTypes.find(
              (item) => item.id == this.model.audit2_type
            ).label,
          });

          return res;
        }
      });
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('roles/indexfield'),
        Axios.getMasters('users/indexfield'),
      ])
        .then((response) => {
          const [response_business, response_roles, response_users] = response;
          this.businesses = this.concatAll(response_business.data.data);
          this.roles = response_roles.data.data;
          this.users = response_users.data.data;

          let editForm = {};
          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            editForm = JSON.parse(sessionStorage.getItem('editForm'));
            this.model.audit2_type = editForm.audit2_type;
            this.model.name = convertFirstLetterUppercase(editForm.name);
            this.model.total_records = editForm.total_records;
            this.model.record_name = editForm.record_name;
            this.model.discount_percentage = editForm.discount_percentage;
            this.model.description = editForm.description;
            this.model.catch_type = editForm.catch_type;
            this.change_type = editForm.change_type;
            this.model.businesses_id = editForm.businesses_ids;
            this.model.roles_id = editForm.roles_id;
            this.model.users_id = editForm.users_id;
            this.model.signature = editForm.signature === 1 ? true : false;
            this.model.where_to_use = editForm.where_to_use;
          }

          if (sessionStorage.getItem('editForm') === null) {
            this.model.businesses_id = this.selectElementsAsignFromModel(
              1,
              this.model.businesses_id,
              this.businesses
            );
            this.model.businesses_id === null &&
              this.businesses.length == 1 &&
              this.model.businesses_id.push(this.businesses[0].id);
          }

          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
<style></style>
